import { MarketConfig } from '../../types/markets/MarketConfig';

export default new MarketConfig(
  'pt_BR',
  {
    fdidYouMean: false,
    ffacetNavigation: false,
    fdomainSuggestions: false,
    fvideo: false,
    fCommerceCarrossel: true,
    resultTiles: false,
    dealerWidget: false,
    frelatedsearch: false,
  },
  {
    fssInputCategory: true,
  },
  'da56c039-5216-4ca4-9a29-f2a2b171b323',
  ''
);
